export default class LoginComponent {
    constructor(jquerySelector,onLoginSuccess,onLoginFailed) {
        this.selector = jquerySelector;
        this.form = jquerySelector.find('form');



        this.initSubmitEvent(onLoginSuccess,onLoginFailed);
    }

    initSubmitEvent(onLoginSuccess,onLoginFailed) {
        this.form.on('submit', (event) => this.formSubmitted(event,onLoginSuccess,onLoginFailed))
    }

    formSubmitted(event, onLoginSuccess,onLoginFailed) {
        $.ajax({
            'url' : '/account/login',
            type  : 'POST',
            data :  {
                login : {
                    email : $('#login-email').val(),
                    pass : $('#login-pass').val()
                }
            },
            success : response => onLoginSuccess(response),
            error : response => onLoginFailed(response.responseJSON)
        });

        event.preventDefault();
    }
}